import { render, staticRenderFns } from "./couponPropertyUserDetailList.vue?vue&type=template&id=4552692a&scoped=true"
import script from "./couponPropertyUserDetailList.vue?vue&type=script&lang=js"
export * from "./couponPropertyUserDetailList.vue?vue&type=script&lang=js"
import style0 from "./couponPropertyUserDetailList.vue?vue&type=style&index=0&id=4552692a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4552692a",
  null
  
)

export default component.exports